import compose from '@aveneo/frontmoon-utils/lib/hocs/compose';

import withInitializeRestaurant from './withInitializeRestaurant';
import connectContainer from './withInitializeRestaurantContainer';

export default compose(
    connectContainer,
    withInitializeRestaurant
);
